import i18n from "i18next";
import EventEmitter from "wolfy87-eventemitter";

import {
  routerEnum,
  reportTypeEnum,
  existStatusEnum,
  menuAuthorityTypeEnum,
  interceptorTypeEnum,
  BMMenuStateEnum,
  urlMatchEnum,
} from "./enum";
import url from "./url";
import { getWindow } from "ssr-window";

function Config() {
  this.ignorePageList = [
    {
      url: url.notFound,
      itemId: "175df854-1f90-4fa2-9d76-e0802d024604",
      requireAuth: false,
      type: interceptorTypeEnum.common,
    },
    {
      url: url.internetError,
      itemId: "3ad64df7-ae87-4a9b-a47a-254f22182e28",
      requireAuth: false,
      type: interceptorTypeEnum.common,
    },
    {
      url: url.forbidden,
      itemId: "c6236def-df5a-432e-a345-b4904061bc9a",
      requireAuth: false,
      type: interceptorTypeEnum.common,
    },
    {
      url: url.BMForbidden,
      itemId: "121b8d92-c7ed-4328-b643-077c7cb8e9a3",
      requireAuth: false,
      type: interceptorTypeEnum.common,
    },
    {
      url: url.lp,
      itemId: "6dfdf6b0-4786-532b-854a-3abf4b2d2b99",
      requireAuth: false,
      type: interceptorTypeEnum.lp,
    },
    {
      url: url.lpNews,
      itemId: "b5a2c7c4-aee3-4c7a-a176-0fa7ce44ca4c",
      requireAuth: false,
      type: interceptorTypeEnum.lp,
    },
    {
      url: url.lpTerms,
      itemId: "9101a390-1642-4f4b-b517-90aaaa29c047",
      requireAuth: false,
      type: interceptorTypeEnum.lp,
    },
    {
      url: url.lpNewsDetail,
      templateName: "NewPage",
      requireAuth: false,
      type: interceptorTypeEnum.lp,
    },
    {
      url: url.lpPrivacyPolicy,
      itemId: "63f14128-9273-4743-aff7-5ab008b73032",
      requireAuth: false,
      type: interceptorTypeEnum.lp,
    },
    {
      url: url.register,
      itemId: "fda42cf1-c290-4bf6-a174-bcb0b2e69a2a",
      requireAuth: false,
      type: interceptorTypeEnum.lp,
    },
    {
      url: url.confirmAgreement,
      itemId: "370e4701-16b4-44ea-9cfa-8799a8ecd62a",
      requireAuth: false,
      type: interceptorTypeEnum.lp,
    },
    {
      url: url.confirmPrivacyPolicy,
      itemId: "fdea125a-b503-4d49-ac38-e4e9609b9792",
      requireAuth: false,
      type: interceptorTypeEnum.lp,
    },
    {
      url: url.confirmInquiry,
      itemId: "07f799b6-4689-43a2-a2b1-fbd237e074e5",
      requireAuth: false,
      type: interceptorTypeEnum.lp,
    },
    {
      url: url.initialRegisterInfoEdit,
      itemId: "15f01f47-94ae-42d8-bd2B-7d72c4893723",
      requireAuth: false,
      type: interceptorTypeEnum.lp,
    },
    {
      url: url.initialRegisterInfoConfirm,
      itemId: "3c180d82-6e78-4c70-9867-fc6414c2b4fa",
      requireAuth: false,
      type: interceptorTypeEnum.lp,
    },
    {
      url: url.initialRegisterInfoDone,
      itemId: "702b3464-b88f-4835-b2c5-b84e6803504d",
      requireAuth: false,
      type: interceptorTypeEnum.lp,
    },
    {
      url: url.initialPasswordEdit,
      itemId: "d3f8eb4f-c33e-42dc-93cb-007285561873",
      requireAuth: true,
      type: interceptorTypeEnum.initialPassword,
    },
    {
      url: url.initialPasswordDone,
      itemId: "5be6f341-8313-4a77-9f98-082ef6d64f50",
      requireAuth: true,
      type: interceptorTypeEnum.initialPassword,
    },
    {
      url: url.initialCompanyInfoEdit,
      itemId: "3b1fc826-34b1-468e-9bcb-21033fe0eac2",
      requireAuth: true,
      type: interceptorTypeEnum.initialCompany,
    },
    {
      url: url.initialCompanyInfoSalesEdit,
      itemId: "fde9b86e-8ebd-4298-a232-39a96c8fb343",
      requireAuth: true,
      type: interceptorTypeEnum.initialCompany,
    },
    {
      url: url.initialCompanyInfoCostEdit,
      itemId: "73683861-9747-4fd3-9761-0f3ed71062d5",
      requireAuth: true,
      type: interceptorTypeEnum.initialCompany,
    },
    {
      url: url.initialCompanyInfoManagementEdit,
      itemId: "01721142-4dec-4f56-982d-403475e311c6",
      requireAuth: true,
      type: interceptorTypeEnum.initialCompany,
    },
    {
      url: url.initialCompanyInfoConfirm,
      itemId: "0a3ef0e7-1aeb-48db-ac0d-590aa4463954",
      requireAuth: true,
      type: interceptorTypeEnum.initialCompany,
    },
    {
      url: url.initialCompanyInfoDone,
      itemId: "813495ff-f28d-46e0-98ec-566b918c9117",
      requireAuth: true,
      type: interceptorTypeEnum.initialCompany,
    },
    {
      url: url.initialUserInfoEdit,
      itemId: "f6b57714-8647-44ae-9e89-1c09026d589f",
      requireAuth: true,
      type: interceptorTypeEnum.initialUser,
    },
    {
      url: url.initialUserInfoConfirm,
      itemId: "14fca6e3-80a7-4947-a373-2450feb44d6f",
      requireAuth: true,
      type: interceptorTypeEnum.initialUser,
    },
    {
      url: url.initialUserInfoDone,
      itemId: "b62b26ae-ec78-4ebe-bb15-1015d8db0dae",
      requireAuth: true,
      type: interceptorTypeEnum.initialUser,
    },
    {
      url: url.confirmSubAgreement,
      itemId: "8dd89707-5f11-41dd-8991-c1748e67b1cd",
      requireAuth: true,
      type: interceptorTypeEnum.confirmSubTerms,
    },
    // 課金-ADD-START
    {
      url: url.confirmSubPaymentAgreement,
      itemId: "e88082a9-babe-4fd5-85c5-f381404a3067",
      requireAuth: true,
      type: interceptorTypeEnum.confirmSubTerms,
    },
    // 課金-ADD-END
    {
      url: url.confirmSubPrivacyPolicy,
      itemId: "ea187a5f-e3c2-4014-aeb1-7ffd9da50a44",
      requireAuth: true,
      type: interceptorTypeEnum.confirmSubTerms,
    },
    {
      url: url.confirmSubInquiry,
      itemId: "9530cb03-8489-4897-9fa2-9325ff3e3236",
      requireAuth: true,
      type: interceptorTypeEnum.confirmSubTerms,
    },
  ];

  this.router = (
    bmServiceStatus,
    menuAuthorityInfo,
    menuBadgeInfo,
    BMMenuState,
    // 課金-ADD-START
    corporationBmServiceAvailabilityFlag
    // 課金-ADD-END
  ) => {
    const routerList = [
      // home
      {
        path: url.home,
        match: urlMatchEnum.home,
        name: i18n.t("TCMS01002_home"),
        title: i18n.t("TCMS01002_home_title"),
        mobileTitle: i18n.t("TCMS01002_home_mobile_title"),
        type: routerEnum.sideBarTop,
        imageSrc: require("@/assets/images/ic_nav_01.svg"),
        selectedImageSrc: require("@/assets/images/ic_nav_01_selected.svg"),
        badge: menuBadgeInfo?.home === existStatusEnum.existence,
        children: [
          {
            path: url.news,
            title: i18n.t("TCMS01002_news_title"),
            mobileTitle: i18n.t("TCMS01002_news_mobile_title"),
            type: routerEnum.other,
          },
        ],
      },
      // mypage
      {
        path: url.mypage,
        match: urlMatchEnum.mypage,
        name: i18n.t("TCMS01002_mypage"),
        title: i18n.t("TCMS01002_mypage_title"),
        mobileTitle: i18n.t("TCMS01002_mypage_mobile_title"),
        type: routerEnum.sideBarTop,
        imageSrc: require("@/assets/images/ic_nav_02.svg"),
        selectedImageSrc: require("@/assets/images/ic_nav_02_selected.svg"),
        badge: menuBadgeInfo?.myPage === existStatusEnum.existence,
        children: [
          {
            path: url.mypageFinancial,
            title: i18n.t("TCMS01002_mypage_financial_title"),
            mobileTitle: i18n.t("TCMS01002_mypage_financial_mobile_title"),
            type: routerEnum.other,
          },
          {
            path: url.mypageFinancialEdit,
            title: i18n.t("TCMS01002_mypage_financial_edit_title"),
            mobileTitle: i18n.t("TCMS01002_mypage_financial_edit_mobile_title"),
            type: routerEnum.other,
          },
          {
            path: url.mypageBusinessMatching,
            title: i18n.t("TCMS01002_mypage_title"),
            mobileTitle: i18n.t("TCMS01002_mypage_mobile_title"),
            type: routerEnum.other,
          },
          {
            path: url.mypageResearchTips,
            title: i18n.t("TCMS01002_mypage_research_tips_title"),
            mobileTitle: i18n.t("TCMS01002_mypage_research_tips_mobile_title"),
            type: routerEnum.other,
          },
          {
            path: url.mypageResearchEconomy,
            title: i18n.t("TCMS01002_mypage_research_economy_title"),
            mobileTitle: i18n.t(
              "TCMS01002_mypage_research_economy_mobile_title"
            ),
            type: routerEnum.other,
          },
          {
            path: url.mypageResearchIndustry,
            title: i18n.t("TCMS01002_mypage_research_industry_title"),
            mobileTitle: i18n.t(
              "TCMS01002_mypage_research_industry_mobile_title"
            ),
            type: routerEnum.other,
          },
        ],
      },
      // pick up
      {
        path: url.pickup,
        title: i18n.t("TCMS01002_pickup_title"),
        mobileTitle: i18n.t("TCMS01002_pickup_mobile_title"),
        type: routerEnum.other,
      },
      // research
      {
        path: url.research,
        match: urlMatchEnum.research,
        name: i18n.t("TCMS01002_research"),
        title: i18n.t("TCMS01002_research_title"),
        mobileTitle: i18n.t("TCMS01002_research_mobile_title"),
        type: routerEnum.sideBarTop,
        imageSrc: require("@/assets/images/ic_nav_03.svg"),
        selectedImageSrc: require("@/assets/images/ic_nav_03_selected.svg"),
        badge: menuBadgeInfo?.researchInfo === existStatusEnum.existence,
        children: [
          {
            path: url.researchSearch,
            title: i18n.t("TCMS01002_research_search_title"),
            mobileTitle: i18n.t("TCMS01002_research_search_mobile_title"),
            type: routerEnum.other,
          },
        ],
      },
      // research related
      {
        path: url.researchRelated,
        title: i18n.t("TCMS01002_research_related_title"),
        mobileTitle: i18n.t("TCMS01002_research_related_mobile_title"),
        type: routerEnum.other,
      },
      // library
      {
        // path: url.library,
        path: url.libraryTrend,
        match: urlMatchEnum.library,
        name: i18n.t("TCMS01002_library"),
        title: i18n.t("TCMS01002_library_title"),
        mobileTitle: i18n.t("TCMS01002_library_mobile_title"),
        type: routerEnum.sideBarTop,
        imageSrc: require("@/assets/images/ic_nav_04.svg"),
        selectedImageSrc: require("@/assets/images/ic_nav_04_selected.svg"),
        badge: menuBadgeInfo?.library === existStatusEnum.existence,
        children: [
          {
            path: url.libraryTrend,
            title: i18n.t("TCMS01002_library_trend_title"),
            mobileTitle: i18n.t("TCMS01002_library_trend_mobile_title"),
            type: routerEnum.other,
          },
          {
            path: url.librarySuccession,
            title: i18n.t("TCMS01002_library_succession_title"),
            mobileTitle: i18n.t("TCMS01002_library_succession_mobile_title"),
            type: routerEnum.other,
          },
          {
            path: url.libraryIPO,
            title: i18n.t("TCMS01002_library_ipo_title"),
            mobileTitle: i18n.t("TCMS01002_library_ipo_mobile_title"),
            type: routerEnum.other,
          },
          {
            path: url.libraryMA,
            title: i18n.t("TCMS01002_library_ma_title"),
            mobileTitle: i18n.t("TCMS01002_library_ma_mobile_title"),
            type: routerEnum.other,
          },
          {
            path: url.libraryFinancialTips,
            title: i18n.t("TCMS01002_library_financial_tips_title"),
            mobileTitle: i18n.t(
              "TCMS01002_library_financial_tips_mobile_title"
            ),
            type: routerEnum.other,
          },
          {
            path: url.libraryNriReport,
            title: i18n.t("TCMS01002_library_nri_report_title"),
            mobileTitle: i18n.t("TCMS01002_library_nri_report_mobile_title"),
            type: routerEnum.other,
          },
          {
            path: url.libraryBusinessReport,
            title: i18n.t("TCMS01002_library_business_report_title"),
            mobileTitle: i18n.t("TCMS01002_library_business_report_mobile_title"),
            type: routerEnum.other,
          },
          {
            path: url.librarySearch,
            title: i18n.t("TCMS01002_library_search_title"),
            mobileTitle: i18n.t("TCMS01002_library_search_mobile_title"),
            type: routerEnum.other,
          },
          {
            path: url.libraryCaseStudyBusinessMatching,
            title: i18n.t(
              "TCMS01002_library_case_study_business_matching_title"
            ),
            mobileTitle: i18n.t(
              "TCMS01002_library_case_study_business_matching_mobile_title"
            ),
            type: routerEnum.other,
          },
          {
            path: url.libraryCaseStudyBusiness,
            title: i18n.t("TCMS01002_library_case_study_business_title"),
            mobileTitle: i18n.t(
              "TCMS01002_library_case_study_business_mobile_title"
            ),
            type: routerEnum.other,
          },
        ],
      },
      // library related
      {
        path: url.libraryCaseStudy,
        title: i18n.t("TCMS01002_library_case_study_title"),
        mobileTitle: i18n.t("TCMS01002_library_case_study_mobile_title"),
        type: routerEnum.other,
      },
      // search
      {
        path: url.search,
        title: i18n.t("TCMS01002_search_title"),
        mobileTitle: i18n.t("TCMS01002_search_mobile_title"),
        type: routerEnum.other,
      },
      // faq
      {
        path: url.faq,
        match: urlMatchEnum.faq,
        name: i18n.t("TCMS01002_faq"),
        title: i18n.t("TCMS01002_faq_title"),
        mobileTitle: i18n.t("TCMS01002_faq_mobile_title"),
        type: routerEnum.sideBarBottom,
        imageSrc: require("@/assets/images/ic_nav_faq.svg"),
        badge: menuBadgeInfo?.faqContact === existStatusEnum.existence,
      },
      // setting
      {
        path: url.settingsCorpProfile,
        match: urlMatchEnum.settings,
        name: i18n.t("TCMS01002_setting"),
        title: i18n.t("TCMS01002_setting_title"),
        mobileTitle: i18n.t("TCMS01002_setting_mobile_title"),
        type: routerEnum.sideBarBottom,
        imageSrc: require("@/assets/images/ic_nav_setting.svg"),
        badge: menuBadgeInfo?.setting === existStatusEnum.existence,
      },
      // footer link
      {
        path: url.terms,
        name: i18n.t("TCMS01002_terms"),
        title: i18n.t("TCMS01002_terms_title"),
        mobileTitle: i18n.t("TCMS01002_terms_mobile_title"),
        type: routerEnum.footer,
      },
      {
        path: url.policyInquiry,
        name: i18n.t("TCMS01002_policy_inquiry"),
        title: i18n.t("TCMS01002_policy_inquiry_title"),
        mobileTitle: i18n.t("TCMS01002_policy_inquiry_mobile_title"),
        type: routerEnum.footer,
      },
      // {
      //   path: url.history,
      //   name: i18n.t("TCMS01002_history"),
      //   title: i18n.t("TCMS01002_history_title"),
      //   mobileTitle: i18n.t("TCMS01002_history_mobile_title"),
      //   type: routerEnum.footer,
      // },
      // {
      //   path: url.pricing,
      //   name: i18n.t("TCMS01002_pricing"),
      //   title: i18n.t("TCMS01002_pricing_title"),
      //   mobileTitle: i18n.t("TCMS01002_pricing_mobile_title"),
      //   type: routerEnum.footer,
      // },
      // {
      //   path: url.policy,
      //   name: i18n.t("TCMS01002_policy"),
      //   title: i18n.t("TCMS01002_policy_title"),
      //   mobileTitle: i18n.t("TCMS01002_policy_mobile_title"),
      //   type: routerEnum.footer,
      // },
      // {
      //   path: url.privacyPolicy,
      //   name: i18n.t("TCMS01002_privacy_policy"),
      //   title: i18n.t("TCMS01002_privacy_policy_title"),
      //   mobileTitle: i18n.t("TCMS01002_privacy_policy_mobile_title"),
      //   type: routerEnum.footer,
      // },
      // {
      //   path: url.antisocialForce,
      //   name: i18n.t("TCMS01002_antisocial_force"),
      //   title: i18n.t("TCMS01002_antisocial_force_title"),
      //   mobileTitle: i18n.t("TCMS01002_antisocial_force_mobile_title"),
      //   type: routerEnum.footer,
      // },
      // {
      //   path: url.antisocialStatement,
      //   name: i18n.t("TCMS01002_antisocial_statement"),
      //   title: i18n.t("TCMS01002_antisocial_statement_title"),
      //   mobileTitle: i18n.t("TCMS01002_antisocial_statement_mobile_title"),
      //   type: routerEnum.footer,
      // },
      // {
      //   path: url.publishedInfo,
      //   name: i18n.t("TCMS01002_information"),
      //   title: i18n.t("TCMS01002_information_title"),
      //   mobileTitle: i18n.t("TCMS01002_information_mobile_title"),
      //   type: routerEnum.footer,
      // },
      // {
      //   path: url.partner,
      //   name: i18n.t("TCMS01002_partner"),
      //   title: i18n.t("TCMS01002_partner_title"),
      //   mobileTitle: i18n.t("TCMS01002_partner_mobile_title"),
      //   type: routerEnum.footer,
      // },
      // lp footer link
      {
        path: url.lpTerms,
        name: i18n.t("TCCs0018_lp_terms"),
        title: i18n.t("TCCs0018_lp_terms_title"),
        mobileTitle: i18n.t("TCCs0018_lp_terms_mobile_title"),
        type: routerEnum.footer,
        notAuthentication: true,
      },
      {
        path: url.lpPrivacyPolicy,
        name: i18n.t("TCCs0018_lp_privacy_policy"),
        title: i18n.t("TCCs0018_lp_privacy_policy_title"),
        mobileTitle: i18n.t("TCCs0018_lp_privacy_policy_mobile_title"),
        type: routerEnum.footer,
        notAuthentication: true,
      },
      // lp
      {
        path: url.lp,
        title: i18n.t("TCCs0018_lp_title"),
        mobileTitle: i18n.t("TCCs0018_lp_mobile_title"),
        type: routerEnum.other,
      },
      {
        path: url.lpNews,
        title: i18n.t("TCLs0029_lp_news_title"),
        mobileTitle: i18n.t("TCLs0029_lp_news_mobile_title"),
        type: routerEnum.other,
      },
      // confirm agreement
      {
        path: url.confirmAgreement,
        title: i18n.t("TCCs0019_confirm_agreement_title"),
        mobileTitle: i18n.t("TCCs0019_confirm_agreement_mobile_title"),
        type: routerEnum.other,
      },
      {
        path: url.confirmPrivacyPolicy,
        title: i18n.t("TCCs0027_confirm_privacy_policy_title"),
        mobileTitle: i18n.t("TCCs0027_confirm_privacy_policy_mobile_title"),
        type: routerEnum.other,
      },
      {
        path: url.confirmInquiry,
        title: i18n.t("TCCs0028_confirm_inquiry_title"),
        mobileTitle: i18n.t("TCCs0028_confirm_inquiry_mobile_title"),
        type: routerEnum.other,
      },
      // confirm sub agreement
      {
        path: url.confirmSubAgreement,
        title: i18n.t("TCCs0019_confirm_sub_agreement_title"),
        mobileTitle: i18n.t("TCCs0019_confirm_sub_agreement_mobile_title"),
        type: routerEnum.other,
      },
      // 課金-ADD-START
      {
        path: url.paymentSelect,
        title: i18n.t("TCMS01002_payment_select_title"),
        mobileTitle: i18n.t("TCMS01002_payment_select_mobile_title"),
        type: routerEnum.other,
      },
      {
        path: url.paymentAgreement,
        title: i18n.t("TCMS01002_payment_agreement_title"),
        mobileTitle: i18n.t("TCMS01002_payment_agreement_mobile_title"),
        type: routerEnum.other,
      },
      {
        path: url.confirmSubPaymentAgreement,
        title: i18n.t("TCCs0032_confirm_sub_payment_agreement_title"),
        mobileTitle: i18n.t(
          "TCCs0032_confirm_sub_payment_agreement_mobile_title"
        ),
        type: routerEnum.other,
      },
      // 課金-ADD-END
      {
        path: url.confirmSubPrivacyPolicy,
        title: i18n.t("TCCs0027_confirm_sub_privacy_policy_title"),
        mobileTitle: i18n.t("TCCs0027_confirm_sub_privacy_policy_mobile_title"),
        type: routerEnum.other,
      },
      {
        path: url.confirmSubInquiry,
        title: i18n.t("TCCs0028_confirm_sub_inquiry_title"),
        mobileTitle: i18n.t("TCCs0028_confirm_sub_inquiry_mobile_title"),
        type: routerEnum.other,
      },
      // 403,bm 403,404,500
      {
        path: url.notFound,
        title: "404",
        type: routerEnum.other,
      },
      {
        path: url.internetError,
        title: "500",
        type: routerEnum.other,
      },
      {
        path: url.forbidden,
        title: "403",
        type: routerEnum.other,
      },
      {
        path: url.BMForbidden,
        title: "403",
        type: routerEnum.other,
      },
      // お知らせ
      {
        path: url.information,
        title: i18n.t("TCCs0032_information_title"),
        mobileTitle: i18n.t("TCCs0032_information_mobile_title"),
        type: routerEnum.other,
      },
    ];

    // 課金-ADD-START
    // 契約とお支払い
    if (corporationBmServiceAvailabilityFlag === existStatusEnum.existence) {
      const index = routerList.findIndex(
        (item) => item.type === routerEnum.sideBarBottom
      );
      routerList.splice(index, 0, {
        path: url.payment,
        match: urlMatchEnum.payment,
        name: i18n.t("TCMS01002_payment"),
        title: i18n.t("TCMS01002_payment_title"),
        mobileTitle: i18n.t("TCMS01002_payment_mobile_title"),
        type: routerEnum.sideBarBottom,
        imageSrc: require("@/assets/images/ic_nav_payment.svg"),
        badge: menuBadgeInfo?.payment === existStatusEnum.existence,
      });
    }
    // 課金-ADD-END

    if (bmServiceStatus === existStatusEnum.existence) {
      const open = BMMenuState !== BMMenuStateEnum.disable;
      const openSetting = BMMenuState === BMMenuStateEnum.allowSetting;
      const disabled = BMMenuState !== BMMenuStateEnum.normal;
      routerList.push(
        // business matching
        {
          path: url.businessMatching,
          match: urlMatchEnum.businessMatching,
          name: i18n.t("TCMS01002_business_matching"),
          title: i18n.t("TCMS01002_business_matching_title"),
          mobileTitle: i18n.t("TCMS01002_business_matching_mobile_title"),
          type: routerEnum.sideBarTop,
          imageSrc: require("@/assets/images/ic_nav_05.svg"),
          selectedImageSrc: require("@/assets/images/ic_nav_05_selected.svg"),
          secondary: true,
          badge: menuBadgeInfo?.businessMatching === existStatusEnum.existence,
          children: [
            {
              path: url.businessMatching,
              name: "ビジネスマッチングホーム",
              disabled,
            },
            // {
            //   name: "法人を探す",
            //   open,
            //   disabled,
            //   children: [
            //     {
            //       path: url.businessMatchingCorporateSearch,
            //       name: "法人検索",
            //       disabled,
            //     },
            //     {
            //       path: url.businessMatchingFavoriteCorporation,
            //       name: "お気に入り法人",
            //       disabled,
            //     },
            //     {
            //       path: url.businessMatchingCorporateHistory,
            //       name: "法人閲覧履歴",
            //       disabled,
            //     },
            //   ],
            // },
            {
              name: "案件を探す",
              open,
              disabled,
              children: [
                {
                  path: url.businessMatchingSearch,
                  name: "案件検索",
                  disabled,
                },
                {
                  path: url.businessMatchingBookmarkUs,
                  name: "お気に入り案件",
                  disabled,
                },
                {
                  path: url.businessMatchingCaseHistory,
                  name: "案件閲覧履歴",
                  disabled,
                },
              ],
            },
            {
              name: "案件を登録・管理する",
              open,
              disabled,
              children: [
                {
                  path: url.businessMatchingEntryCaseNew,
                  name: "新規案件登録",
                  disabled,
                },
                {
                  path: url.businessMatchingEntry,
                  name: "登録済み案件",
                  disabled,
                },
              ],
            },
            {
              name: "案件への問合せ",
              open,
              disabled,
              children: [
                {
                  path: url.businessMatchingCaseInbox,
                  name: "問合せを受けた案件",
                  disabled,
                },
                {
                  path: url.businessMatchingCaseRequest,
                  name: "問合せをした案件",
                  disabled,
                },
              ],
            },
            {
              name: "設定",
              open: openSetting,
              disabled,
              children: [
                {
                  path: url.businessMatchingSettings,
                  name: "法人情報設定",
                  disabled,
                },
                {
                  path: url.businessMatchingActionSettings,
                  name: "動作設定",
                  disabled: !open,
                },
              ],
            },
          ],
        }
      );
    }

    const spotHumanAuthority =
      menuAuthorityInfo &&
      menuAuthorityInfo.find(
        (item) => item.authorityId === menuAuthorityTypeEnum.spotHuman
      );
    if (
      spotHumanAuthority &&
      spotHumanAuthority.authorityExistence === existStatusEnum.existence
    ) {
      routerList.push(
        // spot human
        {
          path: url.spotHuman,
          match: urlMatchEnum.spotHuman,
          name: i18n.t("TCMS01002_spot_human"),
          title: i18n.t("TCMS01002_spot_human_title"),
          mobileTitle: i18n.t("TCMS01002_spot_human_mobile_title"),
          type: routerEnum.sideBarTop,
          imageSrc: require("@/assets/images/ic_nav_06.svg"),
          selectedImageSrc: require("@/assets/images/ic_nav_06_selected.svg"),
          badge:
            menuBadgeInfo?.spotStaffIntroduction === existStatusEnum.existence,
        }
      );
    }

    return routerList;
  };

  this.deliveryDateList = () => {
    return [
      {
        value: "0",
        text: "全期間",
      },
      {
        value: "1",
        text: "1日以内",
      },
      {
        value: "2",
        text: "1週間以内",
      },
      {
        value: "3",
        text: "1ヶ月以内",
      },
      {
        value: "4",
        text: "1年以内",
      },
      {
        value: "5",
        text: "その他の期間",
      },
    ];
  };

  this.libraryNavList = () => {
    return [
      // {
      //   text: i18n.t("TCLs0001_library"),
      //   path: url.library,
      // },
      {
        text: i18n.t("TCLs0001_trend"),
        path: url.libraryTrend,
      },
      {
        text: i18n.t("TCLs0001_business_report"),
        path: url.libraryBusinessReport,
      },
      {
        text: i18n.t("TCLs0001_nri_report"),
        path: url.libraryNriReport,
      },
      {
        text: i18n.t("TCLs0001_succession"),
        path: url.librarySuccession,
      },
      {
        text: i18n.t("TCLs0001_ipo"),
        path: url.libraryIPO,
      },
      // {
      //   text: i18n.t("TCLs0001_ma"),
      //   path: url.libraryMA,
      // },
      {
        text: i18n.t("TCLs0001_financial_tips"),
        path: url.libraryFinancialTips,
      },
    ];
  };

  this.crossSearchNavList = (bmServiceStatus) => {
    const navList = [
      {
        // リサーチ情報
        text: i18n.t("TCMS01003_researchInfo"),
        catagoryid: "report",
      },
      {
        // ライブラリー
        text: i18n.t("TCMS01003_library"),
        catagoryid: "library",
      },
    ];
    if (bmServiceStatus === existStatusEnum.existence) {
      navList.splice(2, 0, {
        // ビジネスマッチング
        text: i18n.t("TCMS01003_business_matching"),
        catagoryid: "businessMatching",
      });
    }

    return navList;
  };

  this.mypageNavList = (bmServiceStatus, menuAuthorityInfo) => {
    const navList = [
      {
        text: i18n.t("TCMS01025_researchInfo"),
        catagoryid: 1,
        path: url.mypage,
      },
    ];
    if (bmServiceStatus === existStatusEnum.existence) {
      navList.push({
        text: i18n.t("TCMS01025_businessMatching"),
        catagoryid: 2,
        path: url.mypageBusinessMatching,
      });
    }

    const financialAuthority =
      menuAuthorityInfo &&
      menuAuthorityInfo.find(
        (item) => item.authorityId === menuAuthorityTypeEnum.financial
      );
    if (
      financialAuthority &&
      financialAuthority.authorityExistence === existStatusEnum.existence
    ) {
      navList.push({
        text: i18n.t("TCMS01025_financialAnalysis"),
        catagoryid: 3,
        path: url.mypageFinancial,
      });
    }

    return navList;
  };

  this.getRouter = (path, list = this.router()) => {
    for (let index in list) {
      const item = list[index];
      if (item.path === path) {
        return item;
      }
      if (item.children && item.children.length > 0) {
        const temp = this.getRouter(path, item.children);
        if (temp) {
          return temp;
        }
      }
    }
  };

  this.getRouterByPath = (path) => {
    const list = this.router();
    const router = this.getRouter(path, list);
    if (router) {
      return router;
    }
    if (path.indexOf(url.researchDetail) !== -1) {
      return {
        path: url.researchDetail,
        title: i18n.t("TCMS01002_research_detail_title"),
        mobileTitle: i18n.t("TCMS01002_research_detail_mobile_title"),
        type: routerEnum.other,
        reportType: reportTypeEnum.research,
      };
    } else if (path.indexOf(url.libraryDetail) !== -1) {
      return {
        path: url.libraryDetail,
        title: i18n.t("TCMS01002_library_detail_title"),
        mobileTitle: i18n.t("TCMS01002_library_detail_mobile_title"),
        type: routerEnum.other,
        reportType: reportTypeEnum.library,
      };
    } else if (path.indexOf(url.lpNewsDetail) !== -1) {
      return {
        path: url.lpNewsDetail,
        title: i18n.t("TCLs0030_lp_news_detail_title"),
        mobileTitle: i18n.t("TCLs0030_lp_news_detail_mobile_title"),
        type: routerEnum.other,
        reportType: reportTypeEnum.LPNews,
      };
    } else if (path.indexOf(url.informationDetail) !== -1) {
      return {
        path: url.informationDetail,
        title: i18n.t("TCCs0032_information_detail_title"),
        mobileTitle: i18n.t("TCCs0032_information_detail_mobile_title"),
        type: routerEnum.other,
        reportType: reportTypeEnum.information,
      };
    }
  };

  this.eventEmitter = this.eventEmitter || new EventEmitter();

  this.mobileMaxWidth = 0; // 767;

  this.isTest = process.env.REACT_APP_TEST_ENV === "true";

  this.pickUpDisplay = process.env.REACT_APP_PICKUP_DISPLAY === "true";

  this.broadcastChannelName = `trinity-broadcast-channel-${
    getWindow().location.host
  }`;

  this.printMargin = [10, 20, 5, 20];

  this.minTokenRequestInterval = 60000; // 60s

  return this;
}

export default new Config();
